// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3tQ6M","actionsCol":"EnrolledClinics_actionsCol__10oLk"};